export default "__VITE_ASSET__DvumB4c1__"